import { Component, OnInit, AfterViewInit, OnDestroy, ViewChildren, ElementRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, FormControlName } from '@angular/forms';
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { BlogService } from "./blog.service";
import { IBlog } from "./blog";
import { DataTable } from "primeng/primeng";
import { GenericValidator } from "../shared/generic-validator";

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { DataTableDirective } from "angular-datatables";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { LoaderService } from "../LoaderService";
declare var $: any;

@Component({
    templateUrl: "./blogs.component.html"
})
export class BlogsComponent implements OnInit, AfterViewInit {
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    public pageTitle: string = 'Blogs';

    blogsList: IBlog[];

    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    dtOptions: DataTables.Settings = {};
    dtTrigger: Subject<any> = new Subject();


    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private appCommonService: AppCommonService,
        public blogService: BlogService,
        public headerAndNavigationService: HeaderAndNavigationService,
        public loaderService: LoaderService
    ) {
        this.appCommonService.pageContentAdditionalClass = "";
        this.appCommonService.pageName = this.pageTitle;

    }
    

    ngOnInit(): void {
        this.headerAndNavigationService.showhideNav(false, true);
        

        this.dtOptions = {
            dom: 'tp',
            pageLength: 10,
            paging: true,
            columns: [{ orderable: true }, { orderable: true }, { orderable: true }, { orderable: false }]
        }
        this.loadBlogsList();
    }

    ngAfterViewInit(): void {
        
    }

    loadBlogsList() {
        this.blogService.getBlogsList()
            .subscribe(
            (blogs: IBlog[]) => {
                this.blogsList = blogs;
                this.dtTrigger.next();
            },
            (error: any) => {
                this.blogService.showError("Blog retrieval problem", <any>error)
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/blogs/blogs.component.ts